exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bio-nav[data-v-61905b7c]{display:flex;flex-wrap:wrap;margin:-.125rem}.bio-nav button[data-v-61905b7c]{margin:.125rem;padding:.25rem .5rem;line-height:1;font-size:14px}.bio-nav button.btn-light[data-v-61905b7c]{border:1px solid #c3ccd5}", ""]);

// exports
